import * as React from 'react';
import { LOCK_AFTER_UNSUCCESSFUL_LOGIN_ATTEMPTS } from 'cb-unified';
import {
  ActionButton,
  addRowToPayload,
  DisplayFieldBlock,
  fetchApi,
  getInitialValuesExistingRow,
  makeCompoundPayload,
  notifyError,
  notifyResponse,
  useCacheRecord,
} from 'gossamer-front-end';
import { User, UserRow, UserView } from 'cb-model';
import { getFieldStringFromPrimitive } from 'packages/gossamer-unified/FieldUtils';

export interface UnsuccessfulLoginAttemptsResetButtonProps {
  user_id: string;
}

export const UnsuccessfulLoginAttemptsResetButton: React.FC<UnsuccessfulLoginAttemptsResetButtonProps> = (props) => {
  const { data, error } = useCacheRecord<UserRow>(User, props.user_id);
  if (!!error) {
    console.error(error);
  }
  const unsuccessfulLoginAttempts = data?.['unsuccessful_login_attempts'] ?? 0;
  return (
    <>
      <DisplayFieldBlock
        key="unsuccessful_login_attempts"
        fieldId="unsuccessful_login_attempts"
        field={UserView.fields.unsuccessful_login_attempts}
        value={getFieldStringFromPrimitive(UserView.fields.unsuccessful_login_attempts.type, unsuccessfulLoginAttempts)}
      />
      {unsuccessfulLoginAttempts >= LOCK_AFTER_UNSUCCESSFUL_LOGIN_ATTEMPTS && (
        <ActionButton
          label="Reset Unsuccessful Login Attempts"
          size="sm"
          variant="danger"
          waiting={!data}
          execute={async (resetCache) => {
            try {
              const payload = makeCompoundPayload('save');
              const row = getInitialValuesExistingRow(User, data);
              row.unsuccessful_login_attempts = 0;
              addRowToPayload(payload, User, row);
              const response = await fetchApi('POST', `/main/~/user-unsuccessful-login-attempts-reset`, payload);
              resetCache(User.id, props.user_id);
              notifyResponse(response);
              // navigate('/admin/user/search');
            } catch (e) {
              notifyError(e, 'An error occurred while resetting unsuccessful login attempts');
            }
          }}
        />
      )}
    </>
  );
};
